module.exports = __webpack_public_path__ + "img/wheat-awn-slash.d850367f.svg";